import React, {useState} from "react";
import {Prompt} from "react-router-dom";
import {Button, CircularProgress, Typography} from "@mui/material";
import {datetime, forms} from "@atttomyx/shared-utils";
import {verbiage} from "@atttomyx/shared-constants";
import {Items} from "../node";
import {
    LabeledAddressForm,
    LabeledDateForm,
    LabeledEmailForm,
    LabeledPhoneForm,
    LabeledStringForm,
    LabeledUrlForm,
    NodeForm,
    TagsForm
} from "../forms";
import {nodeService} from "../../services";
import {nodeUtils} from "../../utils";
import "./addNodePage.css";

const freshData = () => {
    return {
        firstName: null,
        lastName: null,
        phones: [],
        emails: [],
        urls: [],
        addresses: [],
        dates: [],
        others: [],
        tags: [],
        valid: false,
    }
};

const AddNodePage = (props) => {
    const {snackbar, unique, onSave} = props;
    const [data, setData] = useState(freshData());
    const [saving, setSaving] = useState(false);

    const resetForm = () => {
        setData(freshData());
    }

    const submitForm = () => {
        setSaving(true);

        const modified = {
            firstName: data.firstName,
            lastName: data.lastName,
            phones: data.phones,
            emails: data.emails,
            urls: data.urls,
            addresses: data.addresses,
            dates: data.dates,
            others: data.others,
            tags: data.tags,
        };

        const success = (user) => {
            resetForm();
            setSaving(false);

            snackbar.setSuccess("Member saved");
            onSave(user);
        };

        const failure = (err) => {
            setSaving(false);

            snackbar.setError(err);
        };

        nodeService.createNode(modified, success, failure)
    }

    const modified = forms.differ(freshData(), data);

    return saving ?
        <div className="add-node-page">
            <CircularProgress size="80px"/>
        </div> :
        <div className="add-node-page">
            <div className="cards">
                <div className="card">
                    <Typography variant="h5" paragraph={true}>
                        Add member
                    </Typography>
                    <NodeForm
                        data={data}
                        onChange={setData}
                    />
                </div>
                <div className="card outlined">
                    <Items
                        options={unique.phones}
                        data={data}
                        onChange={setData}
                        label="Phone"
                        field="phones"
                        form={LabeledPhoneForm}
                        formatter={nodeUtils.formatPhone}
                    />
                </div>
                <div className="card outlined">
                    <Items
                        options={unique.emails}
                        data={data}
                        onChange={setData}
                        label="Email"
                        field="emails"
                        form={LabeledEmailForm}
                    />
                </div>
                <div className="card outlined">
                    <Items
                        options={unique.urls}
                        data={data}
                        onChange={setData}
                        label="URL"
                        field="urls"
                        form={LabeledUrlForm}
                    />
                </div>
                <div className="card outlined">
                    <Items
                        options={unique.addresses}
                        data={data}
                        onChange={setData}
                        label="Address"
                        field="addresses"
                        form={LabeledAddressForm}
                        toLines={nodeUtils.addressToLines}
                        toItem={nodeUtils.addressToItem}
                    />
                </div>
                <div className="card outlined">
                    <Items
                        options={unique.dates}
                        data={data}
                        onChange={setData}
                        label="Date"
                        field="dates"
                        form={LabeledDateForm}
                        formatter={datetime.getFullDate}
                    />
                </div>
                <div className="card outlined">
                    <Items
                        options={unique.others}
                        data={data}
                        onChange={setData}
                        label="Other"
                        field="others"
                        form={LabeledStringForm}
                    />
                </div>
                <div className="card outlined">
                    <TagsForm
                        options={unique.tags}
                        data={data}
                        onChange={setData}
                    />
                </div>
            </div>
            <div className="actions">
                <Button color="secondary" variant="text"
                        disabled={!modified}
                        onClick={resetForm}>
                    Undo
                </Button>
                <Button color="primary" size="large"
                        disabled={!data.valid || !modified}
                        onClick={submitForm}>
                    Save
                </Button>
            </div>
            <Prompt when={modified} message={verbiage.UNSAVED_CHANGES}/>
        </div>
};

export default AddNodePage;
